import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '@/common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const Toast = ({ message, isVisible, onClose, type = 'success' }) => {
  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(onClose, 3000);
      return () => clearTimeout(timer);
    }
  }, [isVisible, onClose]);

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0, y: 50, x: '-50%' }}
          animate={{ opacity: 1, y: 0, x: '-50%' }}
          exit={{ opacity: 0, y: 20, x: '-50%' }}
          className="fixed bottom-10 left-1/2 z-[100] min-w-[300px]"
        >
          <div className="bg-black text-white p-4 border-2 border-white flex items-center justify-between shadow-2xl">
            <div className="flex items-center gap-3">
              <div className="prism-gradient p-1">
                <SafeIcon icon={type === 'success' ? FiIcons.FiCheck : FiIcons.FiAlertCircle} className="text-black" />
              </div>
              <span className="text-xs font-black tracking-widest uppercase">{message}</span>
            </div>
            <button onClick={onClose} aria-label="Close notification">
              <SafeIcon icon={FiIcons.FiX} />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Toast;